import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CPopoverTooltipComponent } from './c-popover-tooltip.component';
import { IonicModule } from '@ionic/angular';
import { FetchImageFromHtmlModule } from 'src/app/pipes/fetch-image-from-html/fetch-image-from-html.module';
import { TrustHtmlModule } from 'src/app/pipes/trust-html/trust-html.module';



@NgModule({
  declarations: [CPopoverTooltipComponent],
  imports: [
    CommonModule,
    IonicModule,

    // pipes
    FetchImageFromHtmlModule,
    TrustHtmlModule,
  ],
  exports: [CPopoverTooltipComponent]
})
export class CPopoverTooltipModule { }
